// extracted by mini-css-extract-plugin
export var address = "accordion-module--address--f6d6f";
export var social = "accordion-module--social--3fb12";
export var title = "accordion-module--title--2c774";
export var wrapper = "accordion-module--wrapper--b74e7";